/*
 * Live total-pris på køb-knappen for custom tilkøb (.product-addons).
 * Genbruger temaets indbyggede logik: temaets <product-buy-price> lytter på
 * 'bundle:change' og lægger items' priser (i øre) oven i variant-prisen.
 * Vi efterligner ProductBundleDetails.onBundleChange ved at dispatche samme
 * event-format, så vi ikke selv skal beregne/formatere prisen.
 */
(function () {
  function emit(container) {
    var checks = container.querySelectorAll('input[name="bundles"]');
    if (!checks.length) return;
    // form-id sidder på nærmeste [form]-container (fx <details form="...">),
    // ikke på selve inputtet — jf. temaets product-bundle-details-markup.
    var host = checks[0].closest('[form]');
    var formId = host ? host.getAttribute('form') : null;
    var form = formId ? document.forms[formId] : null;
    var items = Array.prototype.slice
      .call(container.querySelectorAll('input[name="bundles"]:checked'))
      .map(function (i) {
        return { id: i.value, quantity: 1, price: i.getAttribute('data-price') };
      });
    (form || document).dispatchEvent(
      new CustomEvent('bundle:change', { detail: { items: items } })
    );
  }

  // Afkrydsning/fravalg af et tilkøb → opdatér total.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'bundles') {
      var c = e.target.closest('.product-addons');
      if (c) emit(c);
    }
  });

  // Efter variant-skift re-renderer temaet køb-knappens basispris;
  // re-emit så de stadig-afkrydsede tilkøb lægges til igen.
  document.addEventListener('variant:change', function () {
    requestAnimationFrame(function () {
      var containers = document.querySelectorAll('.product-addons');
      for (var i = 0; i < containers.length; i++) emit(containers[i]);
    });
  });
})();
